export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '059c369f-42d4-4274-96e8-c10d323c1716';
export const MODAL_CLOSE_SEC = 2.5;
